import { getApiUrl } from '../config/version';

// Detecta si la URL tiene 'www.' o no y devuelve la base correcta
const getBaseURL = () => {
    const currentHost = window.location.hostname; // Obtiene el host actual
    if (currentHost.startsWith('www.')) {
        return 'https://www.suertesolidaria.com';
    } else {
        return 'https://suertesolidaria.com';
    }
};

const baseURL = getBaseURL(); // Obtiene la URL base correcta

// Función para obtener URLs de API con versionado
export const getVersionedApiUrl = (endpoint) => {
    return getApiUrl(`${baseURL}/${endpoint}`);
};

export default baseURL;
